<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>运营</el-breadcrumb-item>
        <el-breadcrumb-item>小程序管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">小程序管理</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="createDialog = true"
          >创建</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >

      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">小程序列表</h3>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            fixed="left"
            align="center"
          ></el-table-column>
          <el-table-column
            label="图标"
            width="100"
            fixed="left"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.icon_url"
                alt=""
                srcset=""
                style="width:50px;height:50px;"
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="名称"
            width="200"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="客户端Id"
            width="150"
            align="center"
            show-overflow-tooltip
            prop="appid"
          >
          </el-table-column>
          <el-table-column
            prop="description"
            label="简介"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="redirect_url"
            label="跳转链接"
            align="center"
            width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="是否热门"
            width="80"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.hot_status==0?'非热门':'热门'}}
            </template>
          </el-table-column>
          <el-table-column
            label="原始Id"
            width="150"
            align="center"
            show-overflow-tooltip
            prop="origin_id"
          >
          </el-table-column>
          <el-table-column
            label="排序值"
            width="80"
            align="center"
            show-overflow-tooltip
            prop="sort"
          >
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="handleToEdit(scope.row)"
              >编辑</el-link>
              <el-link
                type="danger"
                :underline="false"
                @click="handleToRemove(scope.row.id)"
              >删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <div></div>
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <AddMiniprogram
      :isVisible="createDialog"
      @close="createDialog=false"
      @submit="fetchList"
    />
    <EditMiniprogram
      :content="editContent"
      :isVisible="editDialog"
      @close="editDialog=false"
      @submit="fetchList"
    />
  </div>
</template>

<script>

import { miniProgramlist, miniProgramDestory } from "@/api/operation";
import AddMiniprogram from "@/components/dialog/miniprogram/AddMiniprogram";
import EditMiniprogram from "@/components/dialog/miniprogram/EditMiniprogram";




export default {
  components: {
    AddMiniprogram,
    EditMiniprogram
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      createDialog: false,
      editDialog: false,
      editContent: {},
      chooseList: [],
      categorys: [],
      createDatetime: "",
    };
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.start_create_time = this.$moment(value[0]).valueOf();
        this.query.end_create_time = this.$moment(value[1]).valueOf();
      } else {
        this.query.start_create_time = "";
        this.query.end_create_time = "";
        this.fetchList(true)
      }
    },
  },
  created() {
    this.fetchList()

  },
  methods: {

    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      const params = Object.assign({}, this.query);

      miniProgramlist(params).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },


    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
      if (this.query.platform_codes) {
        this.query.platform_codes = this.query.platform_codes.split(",");
      }
      if (this.query.start_create_time && this.query.end_create_time) {
        this.createDatetime = [
          this.$moment(Number(this.query.start_create_time)),
          this.$moment(Number(this.query.end_create_time)),
        ];
      }
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query);
      if (params.platform_codes) {
        params.platform_codes = params.platform_codes.filter((v) => v).join(",");
      }
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        });
    },
    handleToRemove(id) {
      this.$confirm("确定要删除此条信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        miniProgramDestory({ id }).then((res) => {
          this.$nextTick(() => {
            this.fetchList();
          });
        });
      })
    },

    handleToEdit(row) {
      this.editDialog = true
      this.editContent = Object.assign({}, row)
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm("确定要删除这些信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = this.chooseList.map(v => { return v.id })
        articlesubscriblistRemove({ ids }).then((res) => {
          this.fetchList();
        });
      })
    },


  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
.el-tag {
  margin: 0px 5px;
}
.tag-wrap {
  text-align: left;
}
</style>
